import React from 'react'
import styled from 'styled-components'

import { convertWideKanaToHalfKana } from 'utils/commonUtils'
import BaseGroup from './BaseGroup'
import { FormTitleProps } from '../items/FormTitle'
import TextAreaLine from '../items/TextAreaLine'
import { useUpdateLog } from 'utils/log'
import { FormRefarensImageProps } from '../items/FormRefarensImage'

/**
 * MultiTextBoxGroupのタイプ定義
 */
export type MultiTextBoxProps = FormTitleProps &
  FormRefarensImageProps & {
    fields: Array<{
      /** フィールドのkey */
      key: string
      /** 入力テキスト */
      text: string
      /** 入力欄横幅 */
      width: string
      maxLength?: {
        /** 文字数 */
        length: number
        /** 文字数チェックを半角の文字数で確認するフラグ */
        checkHalfStr?: boolean
      }
      /** 入力文字変更時のコールバック */
      onChanged: (value: string) => void
      /** プレースホルダ― */
      placeholder?: string
    }>
  }

/** 複数入力欄グループ */

const MultiTextBoxGroup: React.FC<MultiTextBoxProps> = (props) => {
  const {
    title,
    isRequired,
    isOption,
    description,
    hideTitle,
    fields,
    image,
  } = props

  const [inputText, setInputText] = React.useState<{ [key: string]: string }>(
    fields
      ? fields.reduce((acc, field) => ({ ...acc, [field.key]: field.text }), {})
      : ''
  )

  //  入力値変更時のコールバック
  const handelTextChange = React.useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>, key: string): void => {
      const newText = event.target.value
      const targetField = fields?.find((field) => field.key === key)

      if (
        targetField?.maxLength &&
        (targetField.maxLength.checkHalfStr
          ? convertWideKanaToHalfKana(newText).length
          : newText.length) > (targetField.maxLength.length ?? -1)
      ) {
        return
      }

      setInputText((prev) => ({ ...prev, [key]: newText }))

      if (targetField && targetField.onChanged) {
        targetField?.onChanged(newText)
      }
    },
    [fields]
  )

  useUpdateLog(
    title,
    {
      title: title,
      isRequired: isRequired,
    },
    [props]
  )

  return (
    <BaseGroup
      title={title}
      isRequired={isRequired}
      isOption={isOption}
      description={description}
      hideTitle={hideTitle}
      hasField={Boolean(fields)}
      image={image}
    >
      <Flex>
        {fields?.map((field) => (
          <TextAreaLine
            key={field.key}
            width={field.width}
            inputText={inputText[field.key]}
            placeholder={field.placeholder}
            onChange={(event): void => {
              handelTextChange(event, field.key)
            }}
          />
        ))}
      </Flex>
    </BaseGroup>
  )
}

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`

export default MultiTextBoxGroup
